import Service from 'react-reservice';

import { ICountryAndDialCode } from '@aqx-core/common/api/account';
import { IDemoAccountCreation } from '@aqx-core/common/api/user-account';

import { ESignUpDemoContent } from './types';

export interface ISignUpDemoServiceContext {
  isInitializing: boolean;
  isSubmitting: boolean;
  content: ESignUpDemoContent;
  defaultDeposit: number | undefined;
  countries: ICountryAndDialCode[];
  details?: IDemoAccountCreation;
}

const defaultContext: ISignUpDemoServiceContext = {
  isInitializing: false,
  isSubmitting: false,
  content: ESignUpDemoContent.FORM,
  defaultDeposit: undefined,
  countries: [],
  details: undefined
};

class SignUpDemoService extends Service<ISignUpDemoServiceContext> {
  constructor() {
    super();

    this.context = { ...defaultContext };
  }

  setContent = (content: ESignUpDemoContent) => {
    this.context.content = content;
  };

  setIsInitializing = (isInitializing: boolean) => {
    this.context.isInitializing = isInitializing;
  };

  setIsSubmitting = (isSubmitting: boolean) => {
    this.context.isSubmitting = isSubmitting;
  };

  setDetails = (details: IDemoAccountCreation) => {
    this.context.details = details;
  };

  setCountries = (countries: ICountryAndDialCode[]) => {
    this.context.countries = countries;
  };

  setDefaultDeposit = (amount: number) => {
    this.context.defaultDeposit = amount;
  };

  reset = () => {
    this.context = {
      ...defaultContext
    };
  };
}

export const signUpDemoService = new SignUpDemoService();
